import React, { PureComponent } from 'react';
import { Platform, View, Image, StyleSheet, UIManager } from 'react-native';
import { findNodeHandle } from 'react-native';
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import './ChatView.css';
const uid = UIDs.components.ui.chatView;

const WEB_CONTAINER = 'web_container';

function escapeJSONString(string) {
    return string
        .replace(/[\\]/g, '\\\\')
        .replace(/[\"]/g, '\\\"')
        .replace(/[\']/g, '\\\'')
        .replace(/[\/]/g, '\\/')
        .replace(/[\b]/g, '\\b')
        .replace(/[\f]/g, '\\f')
        .replace(/[\n]/g, '\\n')
        .replace(/[\r]/g, '\\r')
        .replace(/[\t]/g, '\\t');
}

class ChatView extends PureComponent {
    constructor(props) {
        super(props);
        this.setupList = this.setupList.bind(this);
        this.onSetMsgs = this.onSetMsgs.bind(this);
        this.onAddMsg = this.onAddMsg.bind(this);
    }

    componentDidMount() {
        this.props.store.events.addListener("set", this.onSetMsgs);
        this.props.store.events.addListener("add", this.onAddMsg);
        this.initList();
    }

    componentWillUnmount() {
        this.props.store.events.removeListener("set", this.onSetMsgs);
        this.props.store.events.removeListener("add", this.onAddMsg);
    }

    initList() {
        //var msg_list = document.getElementById("msg_list");
        var msg_list = this.msg_list;
        if (msg_list) {
            //msg_list.innerHTML = "";
        }
        this.is_scroll_end = true;
        this.last_append_block = null;
        this.last_prepend_block = null;
    }

    setupList(r) {
        var old_list = this.msg_list;
        this.msg_list = r;
        if (this.msg_list && this.msg_list !== old_list) {
            this._inited = true;
            this.onSetMsgs(this.props.store.msgs);
        }
    }

    onSetMsgs(msgs) {
        if (this._inited) {
            this.clear();
            for (var i = 0; i < msgs.length; ++i) {
                this._addHtml(msgs[i].html);
            }
        }
    }

    onAddMsg(msg) {
        if (this._inited) {
            this._addHtml(msg.html);
            this.scrollToEnd();
        }
    }

    selectAll() {
        // TODO
    }

    copy() {
        // TODO
    }

    clear() {
        if (this._inited) {
            var node = this.msg_list;
            while (node.hasChildNodes()) {
                node.removeChild(node.lastChild);
            }
        }
    }

    scrollToEnd() {
        //var msg_list = document.getElementById("msg_list");
        var msg_list = this.msg_list;
        if (msg_list) {
            msg_list.scrollTop = msg_list.scrollHeight;
        }
    }

    createMsgBlock(html) {
        var block = document.createElement("div");
        block.className = "msg_block";
        var content = document.createElement("div");
        content.innerHTML = html;
        block.appendChild(content);
        return block;
    }

    _addHtml(html) {
        //var view = document.getElementById("msg_list");
        var view = this.msg_list;
        //var old_height = $(document).height();
        var old_height = 0;

        var block = this.createMsgBlock(html);
        var maxline = 500;
        var offset = 0;
        if (view.childNodes.length >= maxline) {
            view.removeChild(view.childNodes[0]);
            //var new_height = $(document).height();
            var new_height = 0;
            offset = new_height - old_height;
        }
        view.appendChild(block);

        if (this.is_scroll_end) {
            this.scrollToEnd();
        }
        else {
            if (offset) {
                //var scroll_top = $(document).scrollTop();
                //$(document).scrollTop(scroll_top + offset);
            }
        }
    }

    queryHeight() {
        if (this._inited) {
            this._sendAction("QUERY_HEIGHT");
        }
    }

    onWebMessage(msg) {
        if (this.props.onHeight) {
            this.props.onHeight(msg.new_height);
        }
    }

    render() {
        return (<View ref={WEB_CONTAINER} style={this.props.style}
                onLayout={(e) => {
                    if (e.nativeEvent.layout.height !== this._lastHeight) {
                        this._lastHeight = e.nativeEvent.layout.height;
                        this.scrollToEnd();
                    }
                }}>
                    <div id="msg_list" ref={this.setupList}
                         style={{padding: 8, overflowX: 'hidden', overflowY: 'auto'}}
                         onScroll={(event) => {
                             //var msg_list = document.getElementById("msg_list");
                             var msg_list = this.msg_list;
                             if (msg_list.scrollTop >= msg_list.scrollHeight - msg_list.clientHeight) {
                                 this.is_scroll_end = true;
                             }
                             else {
                                 this.is_scroll_end = false;
                             }
                         }}>
                    </div>
                </View>);
    }
};

export default withTranslation(uid, { withRef: true })(ChatView);
